/* eslint-disable no-array-constructor */
/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */
/* eslint-disable  */

import React from "react";
import { connect } from "react-redux";
import { updateCategories } from "../../Redux/Categories/actions";
import { appendScript, appendStyle } from "../Functions";
import Footer from "./Footer";
import { rawHeader } from "./Headers/HeaderRaw";
import MainHeader from "./Headers/MainHeader";
import MainNav from "./MainNav";

const HomeLayout = (props) => {
	const { children, isHome=false, categories = [], updateCategories, hideSearch } = props;
	const [loading, setLoading] = React.useState(true);

	React.useEffect(() => {
		appendStyle("assets/css/app.css");
		appendStyle("assets/css/main.css");
		appendScript("assets/js/bundler2.js");
		
		updateCategories();
		setTimeout(() => {
			setLoading(false);
		  }, 2000);


	}, [])
	return (
		<>
			<main>
				{loading && (
					<>
						<div id="pageloader" className="pageloader is-left-to-right" />
						<div id="infraloader" className="infraloader is-active" />
					</>
				)}
			<MainHeader categories={categories} isHome={isHome} hideSearch={hideSearch}/>
                {children}
            </main>
			<Footer />
		</>
	);
};


const mapStateToProps = ({ categories }) => {
	return { categories };
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateCategories: (e) => dispatch(updateCategories(e))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeLayout);
